import React from 'react';
import UserSettings from './components/user-settings';

const User = () => {
  return <UserSettings />;
}

export default User;